import React, { useState } from "react";
import Modal from "../Modal";
import CustomPopup from "../CustomPopup";
import UEvenetCard from "./UEvenetCard";

const DonationCard = ({
  imgUrl,
  heading,
  date,
  summary,
  url,
  className,
  content,
  cause,
}) => {
  const [showModal, setshowModal] = useState(false);
  const closeModal = () => {
    setshowModal(false);
  };
  const readmore = () => {
    setshowModal(true);
  };
  return (
    <>
      <UEvenetCard
        imgUrl={imgUrl}
        date={date}
        heading={heading}
        summary={summary}
        className={className}
        readmore={readmore}
        cause={cause}
      />
      <CustomPopup
        className="modal-lg"
        showModal={showModal}
        closeModal={closeModal}
        heading={heading}
      >
        <div>
          <div
            style={{
              maxWidth: "80%",
              maxHeight: "500px",
            }}
            className="about-img-col"
          >
            <img src={imgUrl} />
          </div>
          <div className="py-3">
            <p>Donation Cause : {cause}</p>
            <div
              className="html_render"
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-end px-2">
            <a href={url} className="btn btn-success" target="__blank">
              Donate
            </a>
          </div>
        </div>
      </CustomPopup>
    </>
  );
};

export default DonationCard;
